<script lang="ts">
export default {
    name: "rightHeader",
};
</script>

<script setup lang="ts">
import axios from 'axios';
import { store } from "@/store"
import { onMounted, onBeforeUnmount } from 'vue';
import Notice from "./notice.vue"
import { getAssetsFile } from '@/utils/pub-use'
import router from "@/router";

interface WeatherQuery {
    adcode?: string,
    city?: string,
    humidity?: string,
    humidity_float?: string,
    province?: string,
    reporttime?: string,
    temperature?: string,
    temperature_float?: string,
    weather?: string,
    winddirection?: string,
    windpower?: string,
}
const weatherValue = reactive<WeatherQuery>({});
const city = ref()
const weather = () => {
    axios.get('https://restapi.amap.com/v3/weather/weatherInfo', {
        params: {
            city: city.value, //你的城市
            key: 'efcdb0d982c73ca59396f1aa26fa0040',//高德api创建项目获取的key
            extensions: 'base'
        }
    }).then(res => {
        // console.log(res)
        if (res.status === 200 && Array.isArray(res.data.lives) && res.data.lives.length) {
            Object.assign(weatherValue, res.data.lives[0]);
        }
    })
}

const timer = ref()
const moreDate = ref()
function nowDate() {
    var time = new Date(new Date().getTime()); //获取到当前时间戳); //创建一个日期对象
    var year = time.getFullYear(); // 年
    var month = (time.getMonth() + 1).toString().padStart(2, '0'); // 月
    var date = time.getDate().toString().padStart(2, '0'); // 日
    moreDate.value = `${year}-${month}-${date}`
}

const moreTime = ref()
function nowTime() {
    const time = new Date()
    const hour = complement(time.getHours())
    const minute = complement(time.getMinutes())
    const second = complement(time.getSeconds())
    moreTime.value = `${hour}:${minute}:${second}`
}

//当时间为个位数的时候，在数字前加0
const complement = (value: number): string => {
    return value < 10 ? `0${value}` : value.toString()
}

const backBtn = () => {
    console.log(window.location.hostname)
    window.parent.postMessage({
            type: 'CHANGE_ROUTE',
            path: '/dashboard'
        }, import.meta.env.VITE_ADMIN_URL); // 最好指定具体的父窗口域名代替 '*'
    // window.location.href = window.location.href;
    // window.location.replace("https://fh.zxhkuav.cn/dashboard")
}

watch(() => store.informationListStore.informationStore().organizationData.cityCode, async (data, oldVal) => {
    console.log(data)
    if (data && !store.informationListStore.informationStore().organizationData.areaCode) {
        city.value = data
        weather()
    }
}, {
    immediate: true,
    deep: true
})

watch(() => store.informationListStore.informationStore().organizationData.areaCode, async (data, oldVal) => {
    console.log(data)
    if (data) {
        city.value = data
        weather()
    }
}, {
    immediate: true,
    deep: true
})

onMounted(() => {
    weather()
    timer.value = setInterval(() => {
        nowDate()
        nowTime()
    }, 1000)
})

//取消定时器
onBeforeUnmount(() => {
    clearInterval(timer.value) //清除定时器
})
</script>

<template>
    <div class="right-header">
        <div class="headerBox">
            <p style="display: flex;align-items: center;font-size: 0.875rem;">
                <span style="width: 2.3vw;">{{ weatherValue.city }}</span>
                <span style="display: inline-block;margin: 0 0.8vw;width: .1vw;height: 2.5vh;background: rgba(157, 197, 232, 0.349);"></span>
                <span style="font-size: 1rem;font-weight: 400;" class="timeBox">
                    <span style="display: block;font-size: .625rem;">{{ moreDate }}</span>
                    <span style="display: block;font-size: 1rem;color: #CDD6E3;text-shadow: 0px 0px 2px #43B8FF;">{{
                        moreTime }}</span>
                </span>
                <span style="display: inline-block;margin: 0 0.8vw;width: .1vw;height: 2.5vh;background: rgba(157, 197, 232, 0.349);"></span>
            </p>
            <div class="weater-box">
                <div style="display: flex;align-items: center;">
                    <p class="weater">
                        <img :src="getAssetsFile('weather-img/' + weatherValue.weather + '.png')" alt="">
                    </p>
                    <p style="font-size: .75rem;">{{ weatherValue.weather }}</p>
                    <div style="font-size: .75rem;color: #fff;display: flex;align-items: center;margin-left: .25rem;">
                        <img style="width: 1.2vw;height: 2.2vh;margin-right: .375rem;" src="@/assets/icons/feng-pic.png" alt="">
                        <span>{{ weatherValue.windpower }}级</span>
                    </div>
                </div>
            </div>
            <p class="backBoX" @click="backBtn">
                <img src="@/assets/icons/gongzuotai.png" alt="">
                <span>工作台</span>
            </p>
        </div>
        <!-- <Notice /> -->
    </div>
</template>

<style scoped lang="scss">
.right-header {
    width: 22.8vw;

    .headerBox {
        position: relative;
        width: 18.6vw;
        height: 3.1vh;
        display: flex;
        margin-top: 1.75rem;
        align-items: center;
        // justify-content: space-around;
        pointer-events: all;
        p {
            font-family: AlibabaPuHuiTi;
            font-size: .875rem;
            color: #FFFFFF;
        }

        .timeBox {
            letter-spacing: 0.54px;
            font-variation-settings: "opsz" auto;
        }

        .weater-box {
            .weater {
                width: 1.1vw;
                height: 1.9vh;
                margin: 0 .4375rem;

                // background-color: #CDD6E3;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .houtai {
            position: absolute;
            top: -10px;
            right: 3.5rem;
            width: 2vw;
            height: 35px;
            cursor: pointer;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .backBoX {
            position: absolute;
            right: -30px;
            cursor: pointer;
            display: flex;
            align-items: center;
            img {
                width: 1.1vw;
                height: 1.9vh;
                margin-right: .375rem;
            }
            span{
                font-size: .75rem;
                font-family: AlibabaPuHuiTi;
            }
        }
    }
}
</style>
